export class TranslationsAlreadyUpToDateError extends Error {
	public constructor(message?: string) {
		super(message);
	}
}
